import {
    authCaptionClass,
    authCaptionStyle,
    authFormShellClass,
    authPhoneClass,
    authPhoneInlineClass,
    authPhoneInlineStyle,
    authPhoneStyle,
    authShellClass,
    authSubtitleClass,
    authSubtitleStyle,
    authTitleClass,
    authTitleStyle,
} from "./authTheme"

export default function AuthShell({
    children,
    className = "",
    variant = "centered",
}: {
    children: React.ReactNode
    className?: string
    variant?: "centered" | "form"
}) {
    const base = variant === "form" ? authFormShellClass : authShellClass
    return <div className={`${base} ${className}`}>{children}</div>
}

export function AuthTitle({ children }: { children: React.ReactNode }) {
    return (
        <h1 className={authTitleClass} style={authTitleStyle}>
            {children}
        </h1>
    )
}

export function AuthSubtitle({ children }: { children: React.ReactNode }) {
    return (
        <p className={authSubtitleClass} style={authSubtitleStyle}>
            {children}
        </p>
    )
}

export function AuthCaption({ children, className = "" }: { children: React.ReactNode; className?: string }) {
    return (
        <p className={`${authCaptionClass} ${className}`} style={authCaptionStyle}>
            {children}
        </p>
    )
}

export function AuthPhoneNumber({ children, className = "" }: { children: React.ReactNode; className?: string }) {
    return (
        <p className={`${authPhoneClass} ${className}`} style={authPhoneStyle}>
            {children}
        </p>
    )
}

export function AuthPhoneInline({ children }: { children: React.ReactNode }) {
    return (
        <span className={authPhoneInlineClass} style={authPhoneInlineStyle}>
            {children}
        </span>
    )
}
